import React from 'react';
import { CacheProvider, withEmotionCache } from '@emotion/react';
import { setNonce } from 'get-nonce';
import { getDocumentNonce } from '../utils/emotionCache';

export default withEmotionCache(({ cache, children }, defaultCache) => {
	if (typeof document !== 'undefined') {
		// Chakra v1 toasts use a separate React root and Emotion's default cache.
		// Reuse that cache in the browser so both roots get the document nonce.
		// Never mutate a shared server cache: _document supplies one per request.
		const { sheet } = defaultCache;
		sheet.nonce = getDocumentNonce();
		// Modal scroll-lock styles are inserted by react-style-singleton.
		setNonce(getDocumentNonce());
	}
	return <CacheProvider value={cache || defaultCache}>{children}</CacheProvider>;
});
